import AppContext from '@src/context'

import React, {useState, useEffect, useContext} from "react"
import { debounce } from '@src/helper'
import PropTypes from "prop-types"
import Loadable from "@loadable/component"
// Style Imports
import "./ISIStickyTray.scss"
// Content Imports
import Isi from "@components/content/isi/ISI.jsx"
const ArrowIcon = Loadable(() => import('@components/content/icons/Arrow.jsx'))

const ISIStickyTray = ({ target }) => {
    const ctx = useContext(AppContext);
    const [zoomed, setZoom] = useState(false)

    const handleZoom = () => {
        if (window.devicePixelRatio > 3) {
            setZoom(true)
        } else {
            setZoom(false)
        }
    }

    const handleThreshold = () => {
        if (ctx.device === 'desktop') {
            ctx.setISIThreshold(150)
        }else {
            ctx.setISIThreshold(164)
        }
    }

    const scrollToContent = (e) => {
        e.preventDefault()
        if (target && target.current) target.current.scrollIntoView({ behavior: 'smooth' })
    }

    useEffect(() => {
        const zoomListener = debounce(handleZoom, 5)
        const thresholdListener = debounce(handleThreshold, 5)
        handleZoom()
        handleThreshold()

        window.addEventListener('resize', zoomListener)
        window.addEventListener('resize', thresholdListener)
        return () => {
            window.removeEventListener('resize', zoomListener)
            window.removeEventListener('resize', thresholdListener)
        }
    },[])

    return (
        <section className={"bg-white isi sticky-tray " + (zoomed ? "sticky-tray--zoomed" : "")}>
            <div className="container">

                <button className="sticky-tray__toggle" onClick={scrollToContent}>
                    <span className="sr-only">Scroll to Important Safety Information</span>
                    <ArrowIcon />
                </button>
                <Isi />
            </div>
        </section>
    )
}

export default ISIStickyTray

ISIStickyTray.propTypes = {
    target: PropTypes.object
}

ISIStickyTray.defaultProps = {
    target: null
}